import { readPreload, buildPreloadKey } from "@/api/preload";

/**
 * `pages/about` 与 `pages/contact` 共用的 `GET /api/front/about` 内嵌预载读取入口
 * （需求 11.13：首帧输出与预渲染 HTML 完全一致）。两个页面各自从同一份响应中
 * 挑选自己需要的字段作为 `useState` 初值，字段提取规则与两个页面各自既有的
 * `useEffect` 内 `.then()` 映射逻辑保持一致。
 */
const ABOUT_PRELOAD_KEY = buildPreloadKey("GET", "/api/front/about");

export function readAboutPreload(): any | undefined {
  return readPreload<any>(ABOUT_PRELOAD_KEY);
}
